import React, { useState } from 'react';
import { Grid, TextField, useMediaQuery, Button, Typography, CircularProgress } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import city from '../resource/city.svg';
import { sendEmail } from '../mailer/Mailer';

import ReportProblemIcon from '@material-ui/icons/ReportProblem';

const useStyles = makeStyles((theme) => ({

    section: {
        height: '100vh',
        backgroundImage: `url(${city})`,
        backgroundSize: 'cover',
    }
}));

const Contact = () => {

    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));

    const [status, setStatus] = useState('');
    const [data, setData] = useState({ name: '', email: '', subject: '', message: '' });
    const [isDirty, setIsDirty] = useState(false);

    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    const emailIsValid = data.email.match(validRegex);
    const messageIsValid = data.message != '';
    const valid = data.name != '' && emailIsValid != '' && data.subject != '' & messageIsValid;


    const handleClean = () => {
        setData({ name: '', email: '', subject: '', message: '' });
        setIsDirty(false);
        setStatus('');
    };

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value });
        setIsDirty(true);
    };

    const handleSuccesfull = () => {

    };

    const handleSend = () => {


        const email = {
            to: ['gjonsson@arenco-it.com', 'nelida.prada@arenco-it.com'],
            cc: [],
            replyTo: [data.email],
            from: 'hola@arenco-it.com',
            template: 'ContactEmailTemplate',
            templatedData: JSON.stringify({ email: data.email, name: data.name, subject: data.subject, message: data.message })
        }

        setStatus('sending');

        sendEmail(email).then(
            function (data) {

                setTimeout(function () {
                    setStatus('sended');
                    setTimeout(function () { setStatus(''); handleClean(); }, 5000);
                }, 2000);

            }).catch(
                function (err) {
                    setStatus('error');
                });

    }

    return (
        <Grid container direction="column" alignItems="center" judtify="center" className={classes.section}>

            <Grid item xs></Grid>

            <Grid item xs={matchesSM ? 9 : 6} container direction="column" spacing={1}>
                <Grid item>

                    <Typography color="primary" variant={matchesSM ? "h6" : "h5"}>Dejanos tu mensaje aquí o por email <a href="mailto:hola@arenco-it.com" style={{ color: theme.palette.primary.main, textDecoration: 'none' }}>hola@arenco-it.com</a></Typography>

                </Grid>
                <Grid item>
                    <TextField
                        fullWidth
                        placeholder="Nombre"
                        variant="outlined"
                        size={matchesSM && "small"}
                        name="name"
                        value={data.name}
                        onChange={(event) => handleChange(event)}></TextField>
                </Grid>
                <Grid item>
                    <TextField
                        fullWidth
                        error={data.email && !emailIsValid}
                        placeholder="Email"
                        variant="outlined"
                        size={matchesSM && "small"}
                        name="email"
                        value={data.email}
                        onChange={(event) => handleChange(event)}></TextField>

                </Grid>
                <Grid item>
                    <TextField
                        fullWidth
                        placeholder="Asunto"
                        size={matchesSM && "small"}
                        variant="outlined"
                        name="subject"
                        value={data.subject}
                        onChange={(event) => handleChange(event)}></TextField>

                </Grid>
                <Grid item>
                    <TextField
                        fullWidth
                        placeholder="Mensaje"
                        size={matchesSM && "small"}
                        variant="outlined"
                        multiline
                        rows={6}
                        name="message"
                        value={data.message}
                        onChange={(event) => handleChange(event)}></TextField>

                </Grid>

                <Grid item>

                    {
                        status === 'error' &&
                        <Typography align="right" color="primary" variant={matchesSM ? "body1" : "h5"}>No pudimos enviar tu consulta<ReportProblemIcon style={{ marginLeft: '0.5em' }} color="primary" /></Typography>}

                    {
                        status === 'sended' &&
                        <Typography align="right" color="primary" variant={matchesSM ? "h6" : "h5"}>Enviado! Te responderemos a la brevedad
                        </Typography>}

                </Grid>

                <Grid item container justify="flex-end" spacing={1}>
                    <Grid item>
                        <Button
                            color="primary"
                            variant="contained"
                            disabled={!isDirty}
                            onClick={() => handleClean()}>Limpiar</Button>

                    </Grid><Grid item>
                        <Button
                            color="primary"
                            variant="contained"
                            disabled={!valid}
                            onClick={() => handleSend()}>
                            {
                                status === 'sending' && <CircularProgress size="1.5em" color="secondary" />
                            }
                            {
                                status === 'sending' ?
                                    '  Enviando' :
                                    '  Enviar consulta'
                            }

                        </Button>



                    </Grid>
                    <Grid item>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs></Grid>
        </Grid >
    );
};

export default Contact;